<template>
  <div class="vd-gl-content">
    <a-row type="flex" class="vd-table-head">
      <a-col flex="auto" class="vd-table-name"> 页面列表</a-col>
      <a-col class="vd-table-tool">
        <a-button @click="open">添加推广页面</a-button>
        <!-- <a-divider type="vertical" /> -->
        <!-- <a-icon class="common-icon" type="reload"></a-icon> -->
      </a-col>
    </a-row>
    <a-table
      row-key="id"
      :data-source="list"
      :pagination="false"
      :loading="loading"
    >
      <a-table-column title="ID" data-index="id" />
      <a-table-column title="推广页面" data-index="path" />
      <a-table-column title="备注" data-index="remark" align="center" />
      <a-table-column title="推广页面" data-index="path_img" align="center">
        <template slot-scope="item">
          <img :src="item" alt="推广页面" style="width: 126px" />
        </template>
      </a-table-column>
      <a-table-column title="状态">
        <template slot-scope="record">
          <a-tag
            v-if="record.status === 1"
            color="red"
            @click="disablePage(record)"
            >禁用</a-tag
          >
          <a-tag v-else color="blue" @click="disablePage(record)">启用</a-tag>
        </template>
      </a-table-column>
      <a-table-column title="操作">
        <template slot-scope="record">
          <a-tooltip
            title="删除页面,同时删除该页面下的二维码和二维码收集的用户信息"
          >
            <a-icon
              class="common-icon"
              type="delete"
              @click="deletePage(record)"
            />
          </a-tooltip>
        </template>
      </a-table-column>
    </a-table>

    <a-modal
      title="添加推广页面"
      :visible="visible"
      :footer="null"
      @cancel="onClose"
    >
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        layout="horizontal"
      >
        <a-form-model-item label="页面路径" prop="path">
          <a-input
            class="vd-input-s"
            v-model="form.path"
            placeholder="小程序中的页面路径"
          />
        </a-form-model-item>
        <a-form-model-item label="备注" prop="remark">
          <a-input
            class="vd-input-s"
            v-model="form.remark"
            placeholder="小程序中的页面路径"
          />
        </a-form-model-item>
        <a-form-model-item label="封面图" prop="path_img">
          <a-upload
            accept="image/*"
            :action="upload_url"
            @change="onChange"
            :beforeUpload="beforeUpload"
            list-type="picture"
            :file-list="fileList"
          >
            <div>
              <template v-if="fileList.length === 0">
                <a-button>
                  <a-icon type="upload" />
                  上传图片
                </a-button>
              </template>
            </div>
          </a-upload>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 14 }">
          <a-button type="primary" @click="submit">
            提交
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import {
  addPromotionPage,
  delete_program_page,
  getPromotionPage,
  upd_program_page,
} from '@/api/program'

export default {
  name: 'page',
  data() {
    const upload_url = this.UPLOAD_URL
    return {
      upload_url,
      active_id: 0,
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      fileList: [],
      list: [],
      visible: false,
      form: {
        path: '',
        remark: '',
      },
      rules: {
        path: [{ required: true, message: '请输入页面路径', trigger: 'blur' }],
        remark: [{ required: true, message: '请输入备注', trigger: 'blur' }],
      },
      loading: false,
    }
  },
  mounted() {
    let query = this.$route.query
    this.active_id = parseInt(query.id)

    if (!this.active_id) {
      this.$message.error('错误的活动参数')
    }
    this.getData()
  },
  methods: {
    getData() {
      getPromotionPage({
        all: 'all',
        active_id: this.active_id,
      }).then((res) => {
        if (res.code === 1) {
          this.list = res.list
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    disablePage(e) {
      upd_program_page({
        page_id: e.id,
        status: e.status,
      }).then((res) => {
        if (res.code === 1) {
          this.getData()
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    deletePage(record) {
      delete_program_page({
        pageId: record.id,
      }).then((res) => {
        if (res.code === 1) {
          this.$message.success(res.msg)
          this.getData()
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    onClose() {
      this.visible = !this.visible
    },
    open() {
      this.visible = !this.visible
      this.form.path = ''
      this.fileList = []
    },
    submit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.fileList.length === 0) {
            this.$message.warning('请上传封面图')
            return false
          }
          addPromotionPage({
            active_id: this.active_id,
            remark: this.form.remark,
            path: this.form.path,
            path_img: this.fileList[0]['thumbUrl'],
          }).then((res) => {
            if (res.code === 1) {
              this.$message.success('添加成功')
              this.getData()
              this.onClose()
            } else {
              this.$message.warning(res.msg)
            }
          })
        }
      })
    },
    onChange(e) {
      let status = e.file.status
      if (status === 'uploading') {
        this.fileList = e.fileList
      } else if (status === 'done') {
        e.fileList.forEach((item) => {
          if (item.status === 'done') {
            if (item.response.code === 1) {
              item.thumbUrl = item.response.info
            }
          }
          return item
        })
        this.fileList = e.fileList
      } else if (status === 'error') {
        console.log('上传错误')
      } else if (status === 'removed') {
        this.fileList = e.fileList
      }
    },
    beforeUpload(file) {
      return new Promise((resolve, reject) => {
        if (file.size >= 1024 * 1024 * 250) {
          this.$message.warning('请上传小于 250KB 的照片')
          reject(false)
        } else {
          resolve(true)
        }
      })
    },
  },
}
</script>

<style scoped></style>
